import { render, staticRenderFns } from "./CustomerServices.vue?vue&type=template&id=8e18c746&scoped=true&"
import script from "./CustomerServices.vue?vue&type=script&lang=js&"
export * from "./CustomerServices.vue?vue&type=script&lang=js&"
import style0 from "./CustomerServices.vue?vue&type=style&index=0&id=8e18c746&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e18c746",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardTitle})
